var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bo-image-banner"},_vm._l((_vm.banners),function(banner){return _c('div',{key:banner.index,class:[
            'image-content',
            {
                'is-single': banner.isSingle === true,
                'grid' : banner.grid === true,
            },
        ]},[(banner.image)?_c('img',{attrs:{"src":banner.image}}):(banner.title)?_c('div',{staticClass:"text-block"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(banner.title))]),_vm._v(" "),_c('div',{staticClass:"subtitle"},[_vm._v(_vm._s(banner.subtitle))]),_vm._v(" "),_c('a',{staticClass:"btn-rounded",attrs:{"href":banner.link,"target":"_blank"}},[_vm._v(_vm._s(banner.buttonText))])]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }